import React from 'react';
type BadgeProps = {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'accent' | 'outline';
  className?: string;
};
export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'primary',
  className = ''
}) => {
  const baseStyles = 'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium';
  const variantStyles = {
    primary: 'bg-primary text-white',
    secondary: 'bg-gray-100 text-gray-800',
    accent: 'bg-accent text-white',
    outline: 'bg-white text-gray-700 border border-gray-300'
  };
  return <span className={`${baseStyles} ${variantStyles[variant]} ${className}`} data-id="element-309">
      {children}
    </span>;
};